import { combineReducers } from "redux";
import authReducer from "./auth/auth.reducer";
import navReducer from "./nav/nav.reducer";
import languageReducer from "./language/language.reducer";
import userReducer from "./user/user.reducer";
import roleReducer from "./role/role.reducer";
import branchReducer from "./branch/branch.reducer";
import staffReducer from "./staff/staff.reducer";
import stripeReducer from "./stripe/stripe.reducer";
import voucherReducer from "./voucher/voucher.reducer";
import rosterReducer from "./roster/roster.reducer";
import requestReducer from "./request/request.reducer";
import reportReducer from "./report/report.reducer";
import timeReducer from "./time_tracking/time_tracking.reducer";
import mediaReducer from "./media/media.reducer";
import incomeStaffReducer from "./incomeStaff/incomeStaff.reducer";
import cashupReducer from "./cashup/cashup.reducer";
import creditNotesReducer from "./credit_notes/credit_notes.reducer";
import incomeReducer from "./income/income.reducer";
import creditRedeemReducer from "./credit_redeem/credit_redeem.reducer";
import serviceReducer from "./service/service.reducer";
import groupReducer from "./group_service/group.reducer";
import refundReducer from "./refund/refund.reducer";
import varReducer from "./var/var.reducer";
import discountReducer from "./discount/discount.reducer";
import jobReducer from "./job/job.reducer";
import incomeDetailReducer from "./income_detail/income_detail.reducer";
import payoutSettingReducer from "./payout_setting/payout_setting.reducer";
import payrateSettingReducer from "./payrate_setting/payrate_setting.reducer";
import payoutDailyReducer from "./payout_daily/payout_daily.reducer";
import payoutStatusReducer from "./payout_status/payout_status.reducer";

const rootReducer = combineReducers({
  authReducer,
  navReducer,
  languageReducer,
  userReducer,
  roleReducer,
  branchReducer,
  staffReducer,
  stripeReducer,
  voucherReducer,
  rosterReducer,
  requestReducer,
  reportReducer,
  timeReducer,
  mediaReducer,
  incomeStaffReducer,
  cashupReducer,
  creditNotesReducer,
  incomeReducer,
  creditRedeemReducer,
  refundReducer,
  serviceReducer,
  groupReducer,
  varReducer,
  discountReducer,

  jobReducer,
  incomeDetailReducer,
  payoutSettingReducer,
  payrateSettingReducer,
  payoutDailyReducer,
  payoutStatusReducer,
});

export default rootReducer;
